import React, { useState, useEffect, useContext } from "react";

import moment from "moment";
import _ from "lodash";

import { connect } from "react-redux";

import AppointmentView from "../AppointmentView/AppointmentView";
import AppointmentPdf from "../AppointmentPdf/AppointmentPdf";
import AppointmentExcel from "../AppoiintmentExcel/AppointmentExcel";

import { Button, Form, Row, Col, Space, notification } from "antd";
import { EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import {
  PageContainer,
  Xpagination,
  Xtable,
} from "../../../component/Xcomponent";
import { dateToString, s3_cdn } from "../../../utils";
// Actions
import {
  getAppointmentList,
  getAppointmentListReset,
} from "../../../action/getAppointmentListAction";
import {
  saveAppointmentCompleteStatus,
  saveAppointmentCompleteStatusReset,
} from "../../../action/saveAppointmentCompleteStatusAction";
import {
  saveAppointmentNotAttendedStatus,
  saveAppointmentNotAttendedStatusReset,
} from "../../../action/saveAppointmentNotAttendedStatusAction";

//Helper
import {
  convertTZ,
  dateTimeFormat,
  dateTimeUTCFormat,
  timeSlotFormat,
  dateFormat,
  timeSlotFormatWithoutAM,
} from "../../../utils";

//CSS
import "./AppointmentList.css";
import {
  InputBox,
  RangePickerBox,
  SelectBox,
  XButton,
} from "./AppointmentListStyle";
import HeaderContext from "../../../context/HeaderContext";
//function
const AppointmentList = (props) => {

  const {
    getAppointmentList,
    getAppointmentListState,
    getAppointmentListReset,
    saveAppointmentCompleteStatus,
    saveAppointmentCompleteStatusState,
    saveAppointmentCompleteStatusReset,
    saveAppointmentNotAttendedStatus,
    saveAppointmentNotAttendedStatusState,
    saveAppointmentNotAttendedStatusReset,
    getDoctorDetailState,
  } = props;
  const initialSearchData = {
    patient_name: "",
    patient_phone: "",
    appointment_no: "",
    appointment_start_date: "",
    appointment_end_date: "",
    appointment_type: "",
    status: "",
  };
  const [searchData, setSearchData] = useState(initialSearchData);
  const [refresh, setRefresh] = useState(0);

  const [tableData, setTableData] = useState([]);
  const search = useLocation().search;
  const page = new URLSearchParams(search).get("page");
  console.log(page);
  const [pagination, setPagination] = useState({
    page: page ? page : 1,
    records: 10,
  });

  // let id:null,
  const [view, setView] = useState({
    visible: false,
    id: null,
  });

  //date
  const [value, onChangeDate] = useState(new Date());

  //form
  const [form] = Form.useForm();

  // const onReset = () => {
  //   document.querySelectorAll("Form.Item")
  //   this.setState({
  //     //Form.Item.value:[{}]// Item: [{}],
  //   })
  // }

  //columns
  const columns = [
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      render: (data) => (
        <>
          <span style={{ fontWeight: 600 }}>
            {timeSlotFormat(data.time_slot_start)}
          </span>
          <br />
          <span>{timeSlotFormat(data.time_slot_end)}</span>
        </>
      ),
    },
    {
      title: "Appointment Date",
      dataIndex: "date",
      key: "appintmentdate",
      render: (data) => <span style={{ fontWeight: 600 }}>{data}</span>,
    },
    {
      title: "Patient",
      dataIndex: "pname",
      key: "pname",
      render: (data) => (<><img src={data.profile_pic} style={{borderRadius: '50px', boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.1)'}} width="15px" height="15px"></img>&nbsp;&nbsp;<span style={{ fontWeight: 600 }}>{data.name}</span></>),
    },
    {
      title: "Appointment No.",
      dataIndex: "appNo",
      key: "appNo",
    },
    {
      title: "Contact",
      dataIndex: "contact",
      key: "contact",
    },
    {
      title: "Booked Date",
      dataIndex: "bookedDate",
      key: "bookeddate",
    },
    {
      title: "Amount Paid",
      dataIndex: "amountpaid",
      key: "amountpaid",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <>
          {status === "not attended" && (
            <span style={{width:"fit-content"}} className="not-attended booked-status d-flex">{status}</span>
          )}
          {status === "pending" && (
            <span style={{width:"fit-content"}} className="pending booked-status d-flex">{status}</span>
          )}
          {status === "cancelled" && (
            <span style={{width:"fit-content"}} className="cancelled booked-status d-flex">{status}</span>
          )}
          {status === "completed" && (
            <span style={{width:"fit-content"}} className="completed booked-status d-flex">{status}</span>
          )}
        </>
      ),
    },
    {
      title: "Action",
      key: "id",
      dataIndex: "id",
      render: (data) => (
        <Space size="small">
          <Button
            size="small"
            // shape="circle"
            text="Details"
            icon={<EyeOutlined style={{ color: "#883DA9" }} />}
            onClick={() => setView({ id: data.id, visible: true })}
          />
          {data.status === "pending" &&
            data.payment_status === "success" &&
            data.show && (
              <XButton
                size="small"
                type="primary"
                // shape="round"
                onClick={() => completeStatus(data.id)}
                style={{ fontSize: 14 }}
              >
                Completed
              </XButton>
            )}
          {data.status === "pending" &&
            data.payment_status === "success" &&
            data.show && (
              <XButton
                size="small"
                danger
                // shape="round"
                onClick={() => notAttendedStatus(data.id)}
                style={{ fontSize: 14 }}
              >
                Not Attended
              </XButton>
            )}
        </Space>
      ),
    },
  ];
  const {setTitle} = useContext(HeaderContext);
  setTitle("Upcoming Bookings");
  
  // Callback
  useEffect(() => {
    const appointment_type = new URLSearchParams(search).get("type");
    setSearchData({ ...searchData, ["appointment_type"]: appointment_type });
    form.setFieldsValue({
      appointment_type: appointment_type,
    });
    if (appointment_type !== null) {
      setRefresh(refresh + 1);
    }
    return () => {
      getAppointmentListReset();
    };
  }, []);

  useEffect(() => {
    getAppointmentList({
      patient_name: searchData.patient_name,
      patient_phone: searchData.patient_phone,
      appointment_no: searchData.appointment_no,
      appointment_start_date: searchData.appointment_start_date,
      appointment_end_date: searchData.appointment_end_date,
      appointment_type: searchData.appointment_type,
      status: searchData.status,
      page: pagination.page,
      records: pagination.records,
    });
  }, [pagination, refresh]);

  useEffect(() => {
    if (getAppointmentListState.apiState === "success") {
      let tableData = [];
      getAppointmentListState.list.map((data) => {
        let date = moment(data.to_date).utc().unix();
        let current_date = convertTZ(
          moment().format("YYYY-MM-DD HH:mm:ss") + " +0000",
          "Asia/Kolkata"
        );
        current_date = moment(current_date).utc().unix();
        let show = false;
        if (date <= current_date) {
          show = true;
        }

        tableData.push({
          time: {
            time_slot_start: data.time_slot_start,
            time_slot_end: data.time_slot_end,
          },
          appNo: data.appointment_no,
          pname: data.some_one_else
            ? {
                name: data.full_name,
                profile_pic: "/images/svg/avatar_transgender.svg"
              }
            : data.patient_id
            ? {
                name: `${data.patient_id?.name?.firstName} ${data.patient_id?.name?.lastName}`,
                profile_pic: data.patient_id?.profile_pic ? 
                  `${s3_cdn()}patient/${data.patient_id?.profile_pic}` 
                  :
                  data.patient_id?.gender==="female" ? 
                  `/images/svg/avatar_female.svg` :
                  data.patient_id?.gender==="male" ? 
                  `/images/svg/avatar_male.svg` : 
                  `/images/svg/avatar_transgender.svg`
              }
            : {
              name: "Patient",
              profile_pic: "/images/svg/avatar_transgender.svg"
            },
          date: dateToString(data.date),
          email: data.some_one_else ? data.email : data.patient_id?.email,
          contact: data.some_one_else ? data.phone : data.patient_id?.phone,
          bookedDate: dateFormat(data.createdAt),
          amountpaid: data.total_amount,
          status: data.status,
          id: {
            id: data._id,
            status: data.status,
            payment_status: data.payment_status,
            show: show,
          },
        });
      });
      //tableData = _.orderBy(tableData).reverse();
      setTableData(tableData);
    } else if (getAppointmentListState.apiState === " error") {
    }
  }, [getAppointmentListState]);

  useEffect(() => {
    if (saveAppointmentCompleteStatusState.apiState === "success") {
      notification["success"]({
        message: saveAppointmentCompleteStatusState.message,
        placement: "topRight",
      });
      setRefresh(refresh + 1);
      saveAppointmentCompleteStatusReset();
    }
  }, [saveAppointmentCompleteStatusState]);
  useEffect(() => {
    if (saveAppointmentNotAttendedStatusState.apiState === "success") {
      notification["success"]({
        message: saveAppointmentNotAttendedStatusState.message,
        placement: "topRight",
      });
      setRefresh(refresh + 1);
      saveAppointmentNotAttendedStatusReset();
    }
  }, [saveAppointmentNotAttendedStatusState]);

  // Function
  const completeStatus = (id) => {
    saveAppointmentCompleteStatus({ id: id });
  };
  const notAttendedStatus = (id) => {
    saveAppointmentNotAttendedStatus({ id: id });
  };
  const handleAppointmentDateRangeChange = (value, dateString) => {
    setSearchData({
      ...searchData,
      ["appointment_start_date"]: dateString[0]
        ? moment(dateString[0]).format("YYYY-MM-DD")
        : "",
      ["appointment_end_date"]: dateString[1]
        ? moment(dateString[1]).format("YYYY-MM-DD")
        : "",
    });
  };
  const handleOnChange = (e) => {
    setSearchData({ ...searchData, [e.target.name]: e.target.value });
  };

  const handleOnSelect = (name, value) => {
    setSearchData({ ...searchData, [name]: value });
  };

  //clear filters
  const handleReset = () => {
    form.resetFields();
    setSearchData(initialSearchData);
    setRefresh(refresh + 1);
  };

  //searchfilters
  const searchAppointment = () => {
    setPagination({ page: 1 });
  };

  useEffect(()=>{
    getAppointmentList({ appointment_type: "Upcoming"});
  },[])

  return (
    <>
    {
      getDoctorDetailState.apiState=="success"&&getDoctorDetailState.data.is_dcp_activated==="Yes" ?
      <PageContainer>
    <Form form={form} onFinish={searchAppointment} layout="vertical">
      <Row gutter={24}>
        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
          <Form.Item name="patient_name">
            <InputBox
              type="text"
              name="patient_name"
              onChange={handleOnChange}
              size="large"
              placeholder="Name"
              prefix={<SearchOutlined style={{ color: "#7e7b7b9c" }} />}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
          <Form.Item name="patient_phone">
            <InputBox
              type="text"
              name="patient_phone"
              onChange={handleOnChange}
              size="large"
              placeholder="Phone number"
              prefix={<SearchOutlined style={{ color: "#7e7b7b9c" }} />}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
          <Form.Item name="appointment_no">
            <InputBox
              type="text"
              name="appointment_no"
              onChange={handleOnChange}
              size="large"
              placeholder="Appointment no."
              prefix={<SearchOutlined style={{ color: "#7e7b7b9c" }} />}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
          <Form.Item name="status">
            <SelectBox
              size="large"
              autosize={true}
              style={{ width: "100%" }}
              onChange={(v) => handleOnSelect("status", v)}
              allowClear={true}
              placeholder="All status"
            >
              <option value="pending">Pending</option>
              <option value="completed">Completed</option>
              <option value="cancelled">Cancelled</option>
              <option value="not attended">Not Attended</option>
            </SelectBox>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
          <Form.Item name="appointment_type">
            <SelectBox
              size="large"
              autosize={true}
              style={{ width: "100%" }}
              allowClear={true}
              onChange={(v) => handleOnSelect("appointment_type", v)}
              placeholder="Select Appointment Type"
            >
              <option value="Upcoming">Upcoming appointment</option>
              <option value="Previous">Past appointment</option>
              <option value="Today">Todays appointment</option>
            </SelectBox>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
          <Form.Item name="appointmentstartdatepicker">
            <RangePickerBox
              allowClear={true}
              size="large"
              onChange={handleAppointmentDateRangeChange}
              format={"DD-MMM-YYYY"}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Space style={{ float: "right" }}>
            <Form.Item name="search_btn">
              <XButton
                className="search_btn borderPrimary"
                size="large"
                type="primary"
                htmlType="submit"
              >
                Search
              </XButton>
            </Form.Item>
            <Form.Item name="reset_btn">
              <XButton
                className="borderNonPrimary"
                type="ghost"
                ghost
                onClick={() => handleReset()}
                size="large"
                style={{ width: 100,background:"transparent" }}
              >
                Reset
              </XButton>
            </Form.Item>
          </Space>
        </Col>
      </Row>
    </Form>

        <div className="Appointment list">
          <Xtable
            size="middle"
            columns={columns}
            dataSource={tableData}
            pagination={false}
            scroll={{ x: 768 }}
            loading={getAppointmentListState.apiState === "loading"}
            // title={() => (
            //     <div>
            //         <Button
            //             as="a"
            //             href="/AppointmentPdf"
            //             shape="round"
            //             type="link"
            //             icon={<FilePdfOutlined />}
            //             component={Link}
            //             to="/AppointmentPdf"
            //         >
            //             PDF
            //         </Button>
            //         {` `}
            //         <Button
            //             as="a"
            //             href="/AppointmentExcel"
            //             shape="round"
            //             type="link"
            //             icon={<FileExcelOutlined />}
            //             component={Link}
            //             to="/AppointmentExcel"
            //         >
            //             EXCEL
            //         </Button>
            //     </div>
            // )}
          />
          <Xpagination
            style={{gap:"5px",flexWrap:"wrap"}}
            className="appointmentPagin"
            pageSizeOptions={["10", "25", "50", "100", "500"]}
            showSizeChanger
            total={getAppointmentListState.pagination.total_records}
            onChange={(page, pageSize) =>
              setPagination({ page: page, records: pageSize })
            }
            current={pagination.page}
            defaultPageSize={pagination.records}
            defaultCurrent={1}
            // showTotal={(total, range) =>
            //     `${range[0]}-${range[1]} of ${total} items`
            // }
          />
          <AppointmentView
            id={view.id}
            visible={view.visible}
            jit={searchData.appointment_type}
            onClose={() => setView({ visible: false, id: null })}
          />
        </div>
      </PageContainer>
      :
      <PageContainer>
        <h6>Access Not Authorized</h6>
      </PageContainer>
    }
    </>
    
  );
};

const mapStateToProps = (state) => ({
  getDoctorDetailState: state.getDoctorDetail,
  getAppointmentListState: state.getAppointmentList,
  saveAppointmentCompleteStatusState: state.saveAppointmentCompleteStatus,
  saveAppointmentNotAttendedStatusState: state.saveAppointmentNotAttendedStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getAppointmentList: (params) => dispatch(getAppointmentList(params)),
  getAppointmentListReset: () => dispatch(getAppointmentListReset()),
  saveAppointmentCompleteStatus: (params) =>
    dispatch(saveAppointmentCompleteStatus(params)),
  saveAppointmentCompleteStatusReset: () =>
    dispatch(saveAppointmentCompleteStatusReset()),
  saveAppointmentNotAttendedStatus: (params) =>
    dispatch(saveAppointmentNotAttendedStatus(params)),
  saveAppointmentNotAttendedStatusReset: () =>
    dispatch(saveAppointmentNotAttendedStatusReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentList);
